import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { isNumeric } from '../../objects/CommonUse/checkIfNumeric';
import initializeErrorArray from './objects/initialize_error_array';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import calcRandomNbrWithMax from '../../objects/CommonUse/calc_random_number_with_max';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';

class AddAccountModal extends Component {
      constructor(props) {
          super(props);
          this.state={
              headers: setHeadersForFetch(),
              subProcess: "adminMain",
              environment: Config.dataURL.currentEnv,
              accountRequestLoaded: false,
              waitState: false
          }    
          this.errorArray = initializeErrorArray(5);
          this.dataValidSw = true;
          
}

  componentDidMount(){
      let accountFound = true;
      this.buildAccountNbrArr();
      while (accountFound === true){
        this.accountNbr = calcRandomNbrWithMax(9,false, 6);
        accountFound = this.accountNbrArr.includes(this.accountNbr);
      };
  }

    buildAccountNbrArr(){
        this.accountNbrArr = [];
        for (let i=0; i<this.props.accountList.length; i++){
                let accountNbr = this.props.accountList[i].accountNbr;
                this.accountNbrArr.push(accountNbr);
        }
    }

    populateForm(){
        this.fromName = document.getElementById("fromName").value;
        if (!this.fromName){
            this.dataValidSw = false;
            this.errorMessage = "Email From Name is required for this option.";
        }else{
            this.loadAccountRequest();
        }
    }
 
    editInput(){
        this.dataValidSw = true;
        this.errorArray = initializeErrorArray(5);
        this.getFormValues();
        this.editFormValues();
        if (this.dataValidSw === true){
            this.formatRqstdUsersArr();
            this.saveAccount();
            let accountObj = {accountNbr: this.accountNbr, primaryRole: this.primaryRole, 
            nbrPrimary: this.nbrPrimary, nbrPlayers: this.nbrPlayers}
            this.props.onClose(accountObj);
        }
    }

  getFormValues(){
      this.emailAddress = document.getElementById("emailAddress").value;
      this.primaryRole = document.getElementById("primaryRole").value;
      this.nbrPrimary = document.getElementById("nbrPrimary").value;
      this.nbrPlayers = document.getElementById("nbrPlayers").value;
      this.orgName = document.getElementById("orgName").value;
      this.gradeLevel = document.getElementById("gradeLevel").value;
  }
  
  editFormValues(){
   //  let emailAddressValid = validator.isEmail(this.emailAddress);
    let emailAddressValid = true;
    if (this.emailAddress === ""){
        emailAddressValid = false;
    }else{
        if (this.emailAddress.indexOf('@') <= 0){
            emailAddressValid = false;
        }
    }
    if (emailAddressValid === false){
          this.errorMsg = "Invalid email address";
          this.checkErrorArray(0);
    }
    if (this.primaryRole === "none"){
          this.errorMsg = "Primary Role is required";
          this.checkErrorArray(1);
    }
    
    const validNbrPrimary = isNumeric(this.nbrPrimary);
    if (validNbrPrimary === false){
        this.errorMsg = "Primary Number must be numeric";
        this.checkErrorArray(2);
    }
    const validNbrPlayers = isNumeric(this.nbrPlayers);
    if (validNbrPlayers === false){
        this.errorMsg = "Player Number must be numeric";
        this.checkErrorArray(3);
    }
    if (this.gradeLevel === "none"){
      this.errorMsg = "Required";
      this.checkErrorArray(4);
    }
  } 
     
 checkErrorArray(msgIndex){
    if (this.errorMsg  && this.errorMsg !== ""){
        this.errorArray[msgIndex] = {textType: "text-danger", 
            message: this.errorMsg};
        this.dataValidSw = false;
        this.errorMessage = "Please Correct errors and try-again.";
    }
  }

  formatRqstdUsersArr(){
      const dateObj =  getCurrentDateTime(); 
      this.rqstdUsersArr = [{role: this.primaryRole, dateRqstd: dateObj.date, nbrUsersRqstd: this.nbrPrimary},
          {role: "player", dateRqstd: dateObj.date, nbrUsersRqstd: this.nbrPlayers}];
    
  }

   initializeFormValues(){
        this.emailAddress = this.accountRequestData.replyTo;
        this.primaryRole = this.formData.primaryRole;
        this.nbrPrimary = this.formData.nbrPrimary;
        this.nbrPlayers = this.formData.nbrPlayers;
        this.gradeLevel = this.formData.gradeLevel;
        this.orgName = this.formData.orgName;
        this.howUsing = this.formData.howUsing;
   }
   
    render() {
        if (this.state.accountRequestLoaded === true){
            this.initializeFormValues();
        }
    return <>
         <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
            size="med"  scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title>Add New Account Entry Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {this.state.waitState   ? 
              <WaitTimeSpinner/>
            :
              null
            }
            <form className="text-left">
                <div>
                   <b>Account Number: </b> {this.accountNbr} 
                </div>
                <p className="mt-2">Please complete all fields on this form and then click 
                   'Submit'.</p>
                <div>
                   <label className="font-weight-bold" htmlFor="fromName">
                        Email From Name:&nbsp;&nbsp;</label>
                   <input type="text" className="col-med" id="fromName" name="fromName">
                   </input> 
                </div>
                <div >
                  <label className="mt-2 font-weight-bold" htmlFor="emailAddress">
                    Email Address:</label>
                  <span className={this.errorArray[0].textType}>
                          &nbsp;{this.errorArray[0].message}</span>
                  <input type="text" className="col-med" id="emailAddress" name="emailAddress"
                    value={this.emailAddress}></input> 
                </div>
                <div className="mt-2">
                  <label className="font-weight-bold" htmlFor="primaryRole">Primary Role:</label>
                  <select value={this.primaryRole}
                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="primaryRole">
                        <option value="none">primary role not selected</option>
                        <option value="parent">Parent</option>
                        <option value="teacher">Teacher</option> 
                   </select>
                   <span className={this.errorArray[1].textType}>
                          &nbsp;{this.errorArray[1].message}</span>
                </div>
               
                <div className="mt-2">
                  <label className="font-weight-bold" htmlFor="nbrPrimary">
                        Number of Primary Ids:</label>
                    <span className={this.errorArray[2].textType}>
                          &nbsp;{this.errorArray[2].message}</span>
                   <input type="text" className="col-small" id="nbrPrimary" name="nbrPrimary"
                    value={this.nbrPrimary}></input> 
                </div> 
                               
                <div className="mt-2">
                  <label className="font-weight-bold" htmlFor="nbrPlayers">
                        Number of Player Ids:</label>
                    <span className={this.errorArray[3].textType}>
                          &nbsp;{this.errorArray[3].message}</span>
                   <input type="text" className="col-small" id="nbrPlayers" name="nbrPlayers"
                    value={this.nbrPlayers}></input> 
                  
                </div> 

                <div className="mt-2">
                  <label className="font-weight-bold" htmlFor="orgName">
                        Organization Name:</label>
                  <input type="text" className="col-small" id="orgName" name="orgName"
                    value={this.orgName}></input> 
                  
                </div> 
                <div className="mt-4">
                  <label className="font-weight-bold" htmlFor="gradeLevel">Player Grade Level:&nbsp;&nbsp;</label>
                  <select 
                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="gradeLevel"
                      value={this.gradeLevel}>
                        <option value="none">no grade level slctd</option>
                        <option value="Elementary">Elementary School</option>
                        <option value="MiddleSchool">Middle or Junior High School</option>
                        <option value="HighSchool">High School</option>
                  </select>
                  <span className={this.errorArray[4].textType}>
                          &nbsp;{this.errorArray[4].message}</span>
                </div>
                <div className="mt-2"><b>How Plan to Use Text: </b>{this.howUsing}</div>
               
            </form>
           
           </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
            {this.dataValidSw ?
                <div></div>
            :
                <div className="text-danger font-weight-bold">{this.errorMessage}</div>
            }
            <Button variant="secondary"   onClick={() => this.populateForm()}>
                Populate Form Using Email From Name
            </Button>
            <Button variant="secondary"   onClick={() => this.props.onClose()}>
                Close
            </Button>
            <Button variant="primary"  onClick={() => this.editInput()}>
                Submit
            </Button>
        </Modal.Footer>
        </Modal>
        </>
    }

    loadAccountRequest(){
        this.setState({waitState: true});
        const funcName = "loadAccountRequest";
        const urlParm = "?fromName=" + this.fromName;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            {method:'GET', headers: this.state.headers})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.accountRequestData = output.body;
                            this.formData = this.accountRequestData.formData;
                            this.setState({accountRequestLoaded: true, waitState: false});
                        }else{
                            if (statusCode === 230 || statusCode === 250){
                                this.dataValidSw = false;
                                this.errorMessage = output.body.message;
                                this.setState({accountRequestLoaded: false, waitState: false});
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message};
                                this.props.processError(errorObj);
                            }
                        }
                    });
                };
            });
    }
  
    saveAccount() {
      const currDateTime = getCurrentDateTime(); 
      this.accountObj = {
              "accountNbr": this.accountNbr,
              "emailAddress": this.emailAddress,
              "gradeLevel": this.gradeLevel,
              "orgName": this.orgName,
              "rqstdUsersArr": this.rqstdUsersArr,
              "dateAdded": currDateTime.date,
              "dateUpdated": currDateTime.date,    
      };
      const funcName = "saveAccountCollection";
      const urlParm = "";
      const uri = buildUrl(this.state.environment, funcName, urlParm);
      fetch (uri,  
          {
          method:'POST',
          headers: this.state.headers,
          body: JSON.stringify(this.accountObj)
          })
          .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        alert("Your account has been saved!")
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.accountObj};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
  }

}



export default AddAccountModal;